export default "__VITE_ASSET__b64050be__"